document.addEventListener("DOMContentLoaded", function () {
  // ---------------------- Team Hover Logic ----------------------
  const buttons = document.querySelectorAll(".team-name");
  const images = document.querySelectorAll(".team-image");
  let activeIndex = 0;

  buttons.forEach((button) => {
    button.addEventListener("mouseover", function () {
      let teamIndex = parseInt(this.getAttribute("data-team"));
      if (teamIndex === activeIndex) return;

      buttons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      images[activeIndex].classList.remove("active");
      images[activeIndex].classList.add("previous");

      images[teamIndex].classList.add("active");
      images[teamIndex].classList.remove("previous");

      activeIndex = teamIndex;
    });
  });
});

  // ---------------------- jQuery Section ----------------------
  $(function () {
    // Tab click in .new-arrival-sec

    // Footer accordion
    $('.custom-footer-middle h2').on('click', function () {
      $(this).next('.custom-footer-item ul, .addres-footer').toggle();
      $(this).toggleClass('active');
    });

    // Player select
    $('.select-player-select-box-item label').click(function () {
      var pselectVal = $(this).text();
      const playerName = $(this).data('player-name');
      const playerNumber = $(this).data('player-number');

      $(this).addClass('active').siblings().removeClass('active');
      $(this).closest('.select-player-select-box').find('h2').text(pselectVal);

      $('#CustomName, #CustomerName').val(playerName).trigger('change');
      $('#CustomNumber, #CustomerNumber').val(playerNumber).trigger('change');

      $(this).closest('.select-player-select-box-main').hide();
    });

    // Sync CustomerName -> CustomName
    $('#CustomerName').on('input', function () {
      $('#CustomName').val($(this).val());
    });

    // Limit jersey number to 2 digits
    $('#CustomerNumber').on('input', function () {
      let val = $(this).val();
      if (+val > 99) val = val.slice(1);
      $('#CustomNumber').val(val);
    });

    // Header Search
    $('.field input.search__input').on('keyup', function() {
      $('.header__search .search-modal').addClass('active');
    });

      // Optional: remove the class when keyup is lost
      $('.field input.search__input').on('blur', function() {
        $('.header__search .search-modal').removeClass('active');
      });

    // Toggle player select box
    $('.select-player-select-box h2').on('click', function () {
      $('.select-player-select-box-main').toggle();
    });

    // Switch between player/personalise
    $('.player').on('click', function () {
      $('.select-player-select-box').show();
      $('.select-personaliz').hide();
    });

    $('.personalise').on('click', function () {
      $('.select-player-select-box').hide();
      $('.select-personaliz').show();
    });

    $('.pdp-none').on('click', function (e) {
      e.preventDefault();
      $('.select-player-select-box, .select-personaliz').hide();
      $('#CustomName, #CustomNumber').val('');
    });

    // Customize checkbox
    $('.customize-check-box li').click(function () {
      $('.customize-check-box li').removeClass('active');
      $(this).addClass('active');
    });

    // Read more toggle
    $('.readmore').click(function () {
      $('.product-detals').addClass('active');
      $(this).hide();
    });

    // // Responsive slick for edition--left
    // function handleSlickSlider() {
    //   const $slider = $('.edition--left');
    //   if (window.matchMedia("(max-width: 550px)").matches) {
    //     if (!$slider.hasClass('slick-initialized')) {
    //       $slider.slick({
    //         infinite: false,
    //         slidesToShow: 1.7,
    //         slidesToScroll: 1,
    //         arrows: true,
    //         dots: false
    //       }); 
    //     }
    //   } else {
    //     if ($slider.hasClass('slick-initialized')) {
    //       $slider.slick('unslick');
    //     }
    //   }
    // }

    // handleSlickSlider();
    // $(window).on('resize', handleSlickSlider);

    // Header menu tab switch
    $(document).on('click', '.header-mega-menu-header .tab', function () {
      $('.header-mega-menu-header .tab').removeClass('active');
      $('.menu-drawer__navigation-container .tab-content').removeClass('active');
      $(this).addClass('active');
      $($(this).attr('data-toggles-target')).addClass('active');
    });
  });



  // ---------------------- Collection Description Toggle ----------------------
function truncateHTMLPreserveTags(html, limit) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  let charCount = 0;
  let reachedLimit = false;

  function truncateNode(node) {
    if (reachedLimit) return null;

    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount + node.textContent.length <= limit) {
        charCount += node.textContent.length;
        return node.cloneNode();
      } else {
        const truncatedText = node.textContent.slice(0, limit - charCount);
        charCount = limit;
        reachedLimit = true;
        return document.createTextNode(truncatedText);
      }
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false);
      for (let i = 0; i < node.childNodes.length; i++) {
        const child = truncateNode(node.childNodes[i]);
        if (child) clone.appendChild(child);
        if (reachedLimit) break;
      }
      return clone;
    }

    return null;
  }

  const resultFragment = document.createDocumentFragment();
  for (let i = 0; i < tempDiv.childNodes.length; i++) {
    const truncated = truncateNode(tempDiv.childNodes[i]);
    if (truncated) resultFragment.appendChild(truncated);
    if (reachedLimit) break;
  }

  const resultDiv = document.createElement('div');
  resultDiv.appendChild(resultFragment);
  return resultDiv.innerHTML.trim();
}


const descElement = document.getElementById('collection-description');
const toggleButton = document.getElementById('toggle-description');

if (descElement && toggleButton) {
  const fullHTML = descElement.innerHTML.trim();
  const isMobile = window.innerWidth <= 768;
  const charLimit = isMobile ? 100 : 200;

  // Generate short HTML while keeping tags
  const shortHTML = truncateHTMLPreserveTags(fullHTML, charLimit);

  if (fullHTML.length > shortHTML.length) {
    descElement.setAttribute('data-full-html', fullHTML);
    descElement.setAttribute('data-short-html', shortHTML);
    descElement.innerHTML = shortHTML;

    toggleButton.style.display = 'inline';
    toggleButton.innerText = 'Read more';

    let expanded = false;
    toggleButton.addEventListener('click', function () {
      if (expanded) {
        descElement.innerHTML = descElement.getAttribute('data-short-html');
        toggleButton.innerText = 'Read more';
      } else {
        descElement.innerHTML = descElement.getAttribute('data-full-html');
        toggleButton.innerText = 'Read less';
      }
      expanded = !expanded;
    });
  }
}

  // ---------------------- Observe product-recommendations for slider init ----------------------
//   const targetNode = document.querySelector('product-recommendations');

//   if (targetNode) {
//     const config = { attributes: true, attributeFilter: ['class'] };

//     const callback = function (mutationsList) {
//       for (const mutation of mutationsList) {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
//           if (!$('.related-product-slider').hasClass('slick-initialized')) {
//             $('.related-product-slider').slick({
//               dots: true,
//               infinite: false,
//               speed: 300,
//               slidesToShow: 4.2,
//               slidesToScroll: 4,
//               responsive: [
//                 {
//                   breakpoint: 1025,
//                   settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 4,
//                     dots: true,
//                     infinite: false
//                   }
//                 },
//                 {
//                   breakpoint: 769,
//                   settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 2
//                   }
//                 },
//                 {
//                   breakpoint: 480,
//                   settings: {
//                     slidesToShow: 1.6,
//                     slidesToScroll: 1
//                   }
//                 }
//               ]
//             });
//           }
//         }
//       }
//     };

//     const observer = new MutationObserver(callback);
//     observer.observe(targetNode, config);
//   }
// });

